import { registerPlugin } from "@capacitor/core";
import { isNative } from ".";

export interface PropertyInfo {
  name: string;
  id: number;
  propertyName: string;
  convertedId: number;
  idMatch: boolean;
}

export interface ClassProperties {
  [className: string]: PropertyInfo[];
}

export interface VehiclePropertyPlugin {
  getAllPropertyClasses(): Promise<{ classes: ClassProperties }>;
  getClassProperties(options: {
    className: string;
  }): Promise<{ className: string; properties: PropertyInfo[] }>;
  convertIdToString(options: {
    propertyId: number;
  }): Promise<{ propertyId: number; propertyName: string; success: boolean }>;
  convertStringToId(options: {
    propertyName: string;
  }): Promise<{ propertyName: string; propertyId: number; success: boolean }>;
}

export const VehicleProperty = registerPlugin<VehiclePropertyPlugin>(
  "VehicleProperty"
);

export const getAllPropertyClasses = async () => {
  if (!isNative) {
    throw new Error("仅在原生环境可用");
  }
  const res = await VehicleProperty.getAllPropertyClasses();
  return res;
};

export const getClassProperties = async (className: string) => {
  if (!isNative) {
    throw new Error("仅在原生环境可用");
  }
  const res = await VehicleProperty.getClassProperties({ className });
  return res;
};

export const convertIdToString = async (propertyId: number) => {
  if (!isNative) {
    throw new Error("仅在原生环境可用");
  }
  const res = await VehicleProperty.convertIdToString({ propertyId });
  return res;
};

export const convertStringToId = async (propertyName: string) => {
  if (!isNative) {
    throw new Error("仅在原生环境可用");
  }
  const res = await VehicleProperty.convertStringToId({ propertyName });
  return res;
};

export default VehicleProperty;
